import React from 'react';
import PropTypes from 'prop-types';

import deliverService from '../../services/DeliveringService';
import navigationService from '../../services/NavigationService';
import sessionReader from '../../store/readHelpers/SessionReader';
import { t } from '../../services/i18nService';
import settingsReader from '../../store/readHelpers/SettingsReader';
import uiService from '../../services/UIService';
import { getA11yAttributesV2 } from '../../services/a11yIIBScreenReaderService';
import ExitTestButtonComponent from '../testOverview/ExitTestButton';

class DeliverButton extends React.Component {
    static propTypes = {
        buttonsDisabled: PropTypes.bool.isRequired,
        isOnline: PropTypes.bool.isRequired,
        timeHasExpired: PropTypes.bool.isRequired,
        ui: PropTypes.object,
        noAttemptedQuestions: PropTypes.bool,
        noUnAttemptedMandatoryQuestions: PropTypes.number,
    };

    navigateToFileDeliveryOptions = () => {
        if (sessionReader.userHasChromeKiosk()) {
            navigationService.navigateToOptionsFileDeliveryChromeApp();
        } else {
            navigationService.navigateToOptionsFileDelivery();
        }
    };

    finishPublicTest = () => {
        deliverService.resetExam();
    };

    navigateToRedirectURL = () => {
        navigationService.navigateToUrl(settingsReader.getRedirectUrl());
    };

    render() {
        const { buttonsDisabled, isOnline, timeHasExpired, ui, noAttemptedQuestions, noUnAttemptedMandatoryQuestions } = this.props;
        const mandatoryQuestionBacktoDashboardButtonEnabled = noUnAttemptedMandatoryQuestions > 0 && timeHasExpired;
        const showSubmitIcon = ui.variables.submit__showSubmitIcon;
        const submitIcon = showSubmitIcon ?
            <i className="fa fa-paper-plane-o fa-fw" aria-hidden="true" />
            : null;

        if (sessionReader.isAutoDeliveringEnabled() && isOnline) {
            if (noAttemptedQuestions && !timeHasExpired) {
                return null;
            }
            if (noUnAttemptedMandatoryQuestions > 0 && timeHasExpired) {
                return (
                    <button
                        id="backToDashboardButton"
                        className="btn"
                        onClick={navigationService.navigateToDashboardTicket}
                        {...getA11yAttributesV2({ 'aria-label': t('delivering.backToDashboard') })}
                        disabled={!mandatoryQuestionBacktoDashboardButtonEnabled}
                    >
                        {submitIcon}{t('delivering.backToDashboard')}
                    </button>
                );
            }

            if (
                !sessionReader.isAutoDeliveringWithManualEnabled()
                && !timeHasExpired
            ) {
                return (
                    <button
                        id="backToDashboardButton"
                        className="btn btn--deliver"
                        onClick={navigationService.navigateToDashboardTicket}
                        disabled={buttonsDisabled}
                        {...getA11yAttributesV2({ 'aria-label': t('delivering.backToDashboardAutoDeliverBtnText') })}
                    >
                        {submitIcon}{t('delivering.backToDashboardAutoDeliverBtnText')}
                    </button>
                );
            }

            if (!sessionReader.isAutoDeliveringWithManualEnabled() || (sessionReader.isAutoDeliveringWithManualEnabled() && timeHasExpired)) {
                return (
                    <button
                        id="backToDashboardButton"
                        className="btn"
                        onClick={navigationService.navigateToDashboardTicket}
                        disabled={buttonsDisabled}
                        {...getA11yAttributesV2({ 'aria-label': t('delivering.backToDashboard') })}
                    >
                        {submitIcon}{t('delivering.backToDashboard')}
                    </button>
                );
            }
        }

        if (sessionReader.isPublicExam()) {
            if (settingsReader.isRedirectUrlEnabled() && !!settingsReader.getRedirectUrl()) {
                const redirectButtonCaption = uiService.shouldUseSimplifiedSummaryPage()
                    ? t('delivering.famContextRedirectToURL')
                    : t('delivering.redirectToURL');

                return (
                    <button
                        id="redirectToUrlButton"
                        className="btn"
                        onClick={this.navigateToRedirectURL}
                        disabled={buttonsDisabled}
                        {...getA11yAttributesV2({ 'aria-label': redirectButtonCaption })}
                    >
                        {submitIcon}{redirectButtonCaption}
                    </button>
                );
            }
            return (
                <button
                    id="reloadTestButton"
                    className="btn"
                    onClick={this.finishPublicTest}
                    disabled={buttonsDisabled}
                    {...getA11yAttributesV2({ 'aria-label': t('delivering.finishTest') })}
                >
                    {submitIcon}{t('delivering.finishTest')}
                </button>
            );
        }

        if (!sessionReader.isAutoDeliveringEnabled() && noUnAttemptedMandatoryQuestions > 0) {
            if (sessionReader.userHasLockDown()) {
                return <ExitTestButtonComponent disabled={false} showButtonForNonLockdown={false} label={t('options.exitChromeApp')} />;
            }
            return (
                <button
                    id="backToDashboardButton"
                    className="btn"
                    onClick={navigationService.navigateToDashboardTicket}
                    disabled={!mandatoryQuestionBacktoDashboardButtonEnabled}
                    {...getA11yAttributesV2({ 'aria-label': t('delivering.backToDashboard') })}
                >
                    {submitIcon}{t('delivering.backToDashboard')}
                </button>
            );
        }

        if (isOnline) {
            return (
                <button
                    id="deliverTest"
                    className="btn btn--deliver"
                    onClick={deliverService.deliverTest}
                    disabled={buttonsDisabled}
                    {...getA11yAttributesV2({ 'aria-label': t('delivering.deliverTestButton') })}
                >
                    {submitIcon}{t('delivering.deliverTestButton')}
                </button>
            );
        }

        return (
            <button
                id="downloadOfflineDelivery"
                className="btn btn--deliver"
                onClick={this.navigateToFileDeliveryOptions}
                disabled={buttonsDisabled}
                {...getA11yAttributesV2({ 'aria-label': t('delivering.downloadOfflineDelivery') })}
            >
                {submitIcon}{t('delivering.downloadOfflineDelivery')}
            </button>
        );
    }
}

export default DeliverButton;
